module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Deb Kastner\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("~Love Courageously~"), _c('Br', [_c('Br', [_vm._v("Award-winning author Deb Kastner writes stories of faith, family and community in a small-town western setting.  Deb’s books contain sigh-worthy heroes and strong heroines facing obstacles that draw them closer to each other and the Lord. She lives in Colorado with her husband. She is blessed with three grown daughters and two grandchildren. She enjoys spoiling her grandkids, movies, music, reading, musical theater and exploring Colorado on horseback.")])], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/6Ze4FM/tc-custom/9781488043055.jpg?1721404362525",
      "alt": "This image is the cover for the book Her Forgotten Cowboy, Cowboy Country"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Her Forgotten Cowboy, Cowboy Country\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("In this inspirational romance, a pregnant woman with amnesia begins to fall in love again with her estranged cowboy husband.")]), _c('br'), _c('br'), _vm._v("Suffering amnesia after a car accident, Rebecca Hamilton arrives back in Serendipity, Texas, pregnant and seeking the baby’s father—her estranged husband, Tanner. Returning to the ranch house they once shared is her best chance at regaining her memories. But will recalling the tragic reason they separated only drive a bigger wedge between Rebecca and the man she’s falling for all over again?\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0